// File: app/src/components/ChatWindow.jsx
import React, { useState, useEffect } from 'react';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import TopicSelector from './TopicSelector';
import ReactMarkdown from 'react-markdown';

export default function ChatWindow() {
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [conversation, setConversation] = useState([]); // Store conversation state

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const res = await fetch('https://auf261dzlb.execute-api.us-east-1.amazonaws.com/dev/v1/games');
        const json = await res.json();
        const parsed = JSON.parse(json.body);
        const formatted = parsed.map(item => ({
          label: item.game_name,
          value: item.s3_folder
        }));
        setTopics(formatted);
      } catch (error) {
        console.error('Failed to fetch topics:', error);
      }
    };
    fetchTopics();
  }, []);

  const handleSendMessage = async (text) => {
    if (!text.trim()) return;

    const userMessage = { type: 'user', text };
    setMessages((prev) => [...prev, userMessage]);
    //setConversation((prev) => [...prev, { role: 'user', content: text }]);
    //const newConversation = [...conversation, { role: 'user', content: text }];
    const newConversation = [
      ...conversation,
      { role: 'user', content: [{ text: text }] }
    ];
    console.log('New conversation:', newConversation);
    setConversation(newConversation); // safe to update here
    setIsTyping(true);

    try {
      const response = await fetch('https://auf261dzlb.execute-api.us-east-1.amazonaws.com/dev/v1/chatpoc', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': '9wh3ucjXyA3IBiUhPF5Zd5Lf29AlqS3x84RzIHKW'
        },
        body: JSON.stringify({
          game_folder: selectedTopic?.value || '',
          question: text,
          conversation: newConversation
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API error: ${response.status}`, errorText);
        throw new Error(`API error: ${response.status}`);
      }

    const data = await response.json();    

    const messageText =
        data?.output?.message?.content?.[0]?.text ?? '[No message text]';
    
    // Extract tags
    function extractBetweenTags(text, tag) {
      const regex = new RegExp(`<${tag}>([\\s\\S]*?)</${tag}>`, 'i');
      const match = text.match(regex);
      return match ? match[1].trim() : null;
    }

    const answer = extractBetweenTags(messageText, 'answer');
    const confidence = extractBetweenTags(messageText, 'confidence');

    // Format to Markdown
    // scroll 📜
    // cosmos 🌌
    // open book 📖
    // green circle 🟢
    // green square 
    // mage 🧙
    // wizard 🧙
    // zombie 🧟
    // dragon 🐉
    // compass 🧭
    // flying saucer 🛸
    // milky way 🌌
    // crystal ball 🔮
    // original brain 🧠
    // candle 🕯️



    const formattedMessage = answer && confidence
      ? `## 🕯️📖 Game Summary\n\n${answer}\n\n---\n**Confidence Level:** ${confidence}/10`
      : messageText;
    
    setMessages((prev) => [...prev, { type: 'assistant', text: formattedMessage }]);
    
    } catch (error) {
      console.error('Error fetching assistant response:', error);
      setMessages((prev) => [...prev, {
        type: 'assistant',
        text: 'There was an error getting a response. Please try again.'
      }]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div style={{
      width: '100%',
      maxWidth: '42rem',
      height: '80vh',
      backgroundColor: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      borderRadius: '0.75rem',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <ChatHeader />
      <TopicSelector topics={topics} onTopicSelect={setSelectedTopic} />
      <ChatMessages messages={messages} isTyping={isTyping} />
      <ChatInput onSend={handleSendMessage} />
    </div>
  );
}
